// extracted by mini-css-extract-plugin
export default {"label":"_9L+4","disablePointerEvents":"BCWw","buttonLabel":"N4VR","labelBox":"e5xb","labelBoxInline":"+ZTW","labelTitleContainer":"PyFt","withoutStartIcon":"rXRf"};